import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import CommonHeadingNBtns from "../common-components/CommonHeadingNBtns";
import { showConfirmAlert } from "../components-react/ReactAlert";
import { add_docs, update_docs } from "../../data/ApiEndpoints";
import { commonPostPutApi } from "../../redux/reducers/commonApiSlice";
import MultiSelect from "../components-react/MultiSelect";
import { all_account_types } from "../common-data/DropdowData";
import { fetchIndividualTypeData } from "../../redux/reducers/dropdownApiSlice";
import SelectDropdown from "../components-react/SelectDropdown";
import { fetchDashboardFeaturesdata } from "../../redux/dashboard-features/featuresSlice";
import { uploadImage } from "../../redux/reducers/postApiSlice";
import ReactQuillTextEditor from "../components-react/inputs/ReactQuillTextEditor";

const validateForm = (formValues, isEdit) => {
  let errors = {};

  if (!formValues.featureName) {
    errors.featureName = "Required!";
  }

  if (!formValues.selectedFeature) {
    errors.selectedFeature = "Required!";
  }

  if (formValues.selectedRleventFor?.length === 0) {
    errors.selectedRleventFor = "Required!";
  }

  if (!formValues.featureDocumentation) {
    errors.featureDocumentation = "Required!";
  }

  if (formValues.isNotify && formValues.selectedStakeholders?.length === 0) {
    errors.selectedStakeholders = "Required!";
  }

  // Validate featureVideosArray
  if (
    formValues.featureVideosArray &&
    Array.isArray(formValues.featureVideosArray)
  ) {
    const arrayLength = formValues.featureVideosArray?.length || 0;

    const featureVideosArrayErrors = formValues.featureVideosArray.map(
      (video, index) => {
        const videoErrors = {};
        if (video.video_path && !video.video_title) {
          videoErrors.video_title = "Required!";
        }

        if (video.video_title && !isEdit && !video.video_path) {
          videoErrors.video_path = "Required!";
        }

        if (
          formValues.featureVideosArray.length > 1 &&
          index !== 0 &&
          (!video.video_title || (!video.video_path && !isEdit))
        ) {
          videoErrors.video_title = "Title or video file is required!";
          videoErrors.video_path = "Title or video file is required!";
        }

        return Object.keys(videoErrors).length > 0 ? videoErrors : null;
      }
    );

    if (featureVideosArrayErrors.some((error) => error !== null)) {
      errors.featureVideosArray = featureVideosArrayErrors;
    }
  }

  // Validate featureExternalLinksArray
  if (
    formValues.featureExternalLinksArray &&
    Array.isArray(formValues.featureExternalLinksArray)
  ) {
    const featureExternalLinksArrayErrors =
      formValues.featureExternalLinksArray.map((link, index) => {
        const linkErrors = {};
        if (link.link_path && !link.link_title) {
          linkErrors.link_title = "Required!";
        }

        if (link.link_title && !link.link_path) {
          linkErrors.link_path = "Required!";
        }

        if (
          formValues.featureExternalLinksArray.length > 1 &&
          index !== 0 &&
          (!link.link_title || !link.link_path)
        ) {
          linkErrors.link_title = "Title or link is required!";
          linkErrors.link_path = "Title or link is required!";
        }

        return Object.keys(linkErrors).length > 0 ? linkErrors : null;
      });

    if (featureExternalLinksArrayErrors.some((error) => error !== null)) {
      errors.featureExternalLinksArray = featureExternalLinksArrayErrors;
    }
  }

  return errors;
};

const DocsForm = ({
  userInfoData,
  rowData,
  isEdit,
  closeModal,
  callFunction,
}) => {
  const dispatch = useDispatch();
  const { postPutLoading } = useSelector((state) => state.common);
  const { individualData } = useSelector((state) => state.dropdown);
  const {
    dashboardFeaturesLoading,
    dashboardFeaturesError,
    dashboardFeatures,
  } = useSelector((state) => state.features);
  const { loading } = useSelector((state) => state.postApi);

  const [allFeatures, setAllFeatures] = useState([]);
  const forminitials = {
    featureName:
      isEdit && rowData?.feature_doc_name ? rowData.feature_doc_name : "",
    selectedFeature:
      isEdit && rowData?.feature_id && rowData?.feature_name
        ? {
            label: rowData?.feature_name,
            value: rowData?.feature_id,
          }
        : "",
    selectedRleventFor:
      isEdit && rowData?.feature_relevant_for?.length > 0
        ? rowData.feature_relevant_for.map((item) => ({
            label: item?.replace(/_/g, " "),
            value: item,
          }))
        : [],
    featureDocumentation:
      isEdit && rowData?.feature_documentation
        ? rowData.feature_documentation
        : "",
    featureVideosArray:
      isEdit && rowData?.feature_videos?.length > 0
        ? rowData.feature_videos.map((video) => ({
            video_title: video?.video_title,
            video_path: video?.video_path,
            video_link: video?.video_path,
          }))
        : [{ video_title: "", video_path: "", video_link: "" }],
    featureExternalLinksArray:
      isEdit && rowData?.feature_external_links?.length > 0
        ? rowData.feature_external_links.map((link) => ({
            link_title: link?.link_title,
            link_path: link?.link_path,
          }))
        : [{ link_title: "", link_path: "" }],
    selectedAccountType: "",
    selectedStakeholders:
      isEdit && rowData?.feature_stakeholders?.length > 0
        ? rowData.feature_stakeholders.map((stakeholder) => ({
            value: stakeholder?.user_id,
            label: `${stakeholder?.name}`,
          }))
        : [],
    isNotify: isEdit && rowData?.is_notified ? true : false,
    isActive: isEdit && rowData?.status === "active" ? true : false,
  };
  const [formValues, setFormValues] = useState(forminitials);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const onChangeInput = (e) => {
    const { name, value, type, checked } = e.target;
    const file = type === "file" ? e.target.files[0] : null;

    setIsSubmit(false);

    setFormValues((prevs) => ({
      ...prevs,
      [name]: type === "checkbox" ? checked : type === "file" ? file : value,
    }));
  };

  const onChangeTextInput = (content, fieldName) => {
    setIsSubmit(false);
    setFormValues((prev) => ({ ...prev, [fieldName]: content }));
  };

  const onChangeInputInArray = async (e, index, arrayName) => {
    const { name, value, files } = e.target;

    setFormValues((prevs) => {
      const updatedFeatures = [...prevs[arrayName]];
      updatedFeatures[index][name] = value;
      return { ...prevs, [arrayName]: updatedFeatures };
    });

    if (name === "video_path" && files?.[0]) {
      const file = files[0];

      handleUploadImage(file, arrayName, index);
    }
  };

  const handleAddMore = (e, name, emptyObject) => {
    e.preventDefault();
    setFormValues((prevs) => ({
      ...prevs,
      [name]: [...prevs[name], emptyObject],
    }));
  };

  const handleRemoveOne = (e, index, name) => {
    e.preventDefault();
    setFormValues((prevs) => ({
      ...prevs,
      [name]: prevs[name].filter((_, idx) => idx !== index),
    }));
  };

  function getAllStakeholders() {
    dispatch(
      fetchIndividualTypeData({
        token: userInfoData?.token,
        qps: `user_types=${formValues.selectedAccountType?.value || ""}`,
        pageNo: 1,
        limit: 100,
      })
    );
  }

  function getDashboardFeatures() {
    const allfilters = {
      page: 1,
      limit: 1000,
    };

    dispatch(
      fetchDashboardFeaturesdata({
        filters: allfilters,
        token: userInfoData?.token,
      })
    );
  }

  const handleUploadImage = async (file, arrayName, index) => {
    setIsSubmit(false);

    try {
      const actionResult = dispatch(
        uploadImage({ file, TOKEN: userInfoData?.token })
      );
      const result = await actionResult;

      if (result?.payload?.status) {
        const uploadedURL = result?.payload?.image_url || "";

        setFormValues((prevs) => {
          const updatedFeatures = [...prevs[arrayName]];
          updatedFeatures[index].video_link = uploadedURL;
          return { ...prevs, [arrayName]: updatedFeatures };
        });

        toast.success("Image Upload Success!");
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.log("handleUploadImage ERROR => ", error);
    }
  };

  const onSubmit = () => {
    setFormErrors(validateForm(formValues, isEdit));
    setIsSubmit(true);
  };

  const handleSubmitForm = async (payload) => {
    const method = isEdit ? "PUT" : "POST";
    const endpoint = isEdit ? update_docs : add_docs;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setIsSubmit(false);
        setFormValues(forminitials);
        callFunction();
        closeModal();
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  useEffect(() => {
    getAllStakeholders();
  }, [formValues.selectedAccountType]);

  useEffect(() => {
    getDashboardFeatures();
  }, []);

  useEffect(() => {
    if (
      !dashboardFeaturesLoading &&
      !dashboardFeaturesError &&
      dashboardFeatures?.status &&
      dashboardFeatures?.data?.length > 0
    ) {
      const allmenus = dashboardFeatures.data?.map((blog) => {
        return { label: blog?.name, value: blog?.uid, info: blog };
      });

      setAllFeatures(allmenus);
    } else {
      setAllFeatures([]);
    }
  }, [dashboardFeaturesLoading, dashboardFeaturesError, dashboardFeatures]);

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const featureRelevantFor = formValues.selectedRleventFor.map(
        (item) => item?.value
      );
      const featureStakeholders = formValues.selectedStakeholders.map(
        (item) => item?.value
      );
      const featureVideos = formValues.featureVideosArray
        .map((item) => {
          if (item?.video_title && item?.video_link) {
            return {
              video_title: item?.video_title || "",
              video_path: item?.video_link || "",
            };
          }
          return null;
        })
        .filter(Boolean);
      const featureExternalLinks = formValues.featureExternalLinksArray
        .map((item) => {
          if (item?.link_title && item?.link_path) {
            return {
              link_title: item?.link_title || "",
              link_path: item?.link_path || "",
            };
          }
          return null;
        })
        .filter(Boolean);

      const userData = {
        feature_doc_name: formValues.featureName || "",
        feature_id: formValues.selectedFeature?.value || "",
        feature_documentation: formValues.featureDocumentation || "",
        feature_relevant_for: featureRelevantFor || "",
        feature_external_links: featureExternalLinks || "",
        feature_stakeholders: featureStakeholders || "",
        feature_videos: featureVideos || "",
        is_notified: formValues.isNotify ? 1 : 0,
        status: formValues.isActive ? "active" : "inactive",
      };

      if (isEdit) {
        userData.uid = rowData?.uid || "";
      }

      const handleConfirm = async () => {
        handleSubmitForm(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure!`,
        "Edit Form",
        "Submit Form"
      );
    }
  }, [isSubmit, formErrors]);

  // console.log("formValues=> ", formValues);

  return (
    <div className="createNewCTOModalContainer feature-docs">
      <CommonHeadingNBtns
        title={`${isEdit ? "Update" : "Add New"} Document`}
        onClose={closeModal}
        onClick={onSubmit}
        isLoading={postPutLoading || loading}
      />
      <form className="formContainer">
        <div className="formInputsGrid fourGridSystem">
          <div className="formInputBox span2">
            <label htmlFor="featureName" className={`formInputLabel `}>
              documentation name <span className="required">*</span>
            </label>

            <input
              type="text"
              placeholder="Enter Text"
              className={`formInput ${
                formErrors?.featureName ? "formError" : ""
              }`}
              name="featureName"
              value={formValues.featureName}
              onChange={onChangeInput}
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="selectedFeature" className={`formInputLabel`}>
              feature <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${
                formErrors.selectedFeature ? "formError" : ""
              }`}>
              <SelectDropdown
                options={allFeatures}
                selectedOption={formValues.selectedFeature}
                setSelectedOption={(selectedValue) =>
                  setFormValues((prevs) => ({
                    ...prevs,
                    selectedFeature: selectedValue,
                  }))
                }
                name="Feature"
              />
            </div>
          </div>

          <div className="formInputBox">
            <label htmlFor="selectedRleventFor" className="formInputLabel">
              relevant for <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper no-border multi-select multi-select-max-width ${
                formErrors.selectedRleventFor ? "error" : ""
              }`}>
              <MultiSelect
                options={all_account_types}
                state={formValues.selectedRleventFor}
                setState={(selectedValue) =>
                  setFormValues((prevs) => ({
                    ...prevs,
                    selectedRleventFor: selectedValue,
                  }))
                }
                name="select multiple from the list"
              />
            </div>
          </div>

          <div className="formInputBox">
            <label htmlFor="selectedAccountType" className={`formInputLabel`}>
              account type
            </label>

            <div
              className={`commonWrapper ${
                formErrors?.selectedAccountType ? "formError" : ""
              }`}>
              <SelectDropdown
                options={all_account_types}
                selectedOption={formValues.selectedAccountType}
                setSelectedOption={(selectedValue) =>
                  setFormValues((prevs) => ({
                    ...prevs,
                    selectedAccountType: selectedValue,
                    selectedStakeholders: [],
                  }))
                }
                name="Account Type"
                isDisable={postPutLoading}
              />
            </div>
          </div>

          <div className="formInputBox">
            <label htmlFor="selectedStakeholders" className="formInputLabel">
              stakeholders to notify{" "}
              {formValues.isNotify && <span className="required">*</span>}
            </label>

            <div
              className={`commonWrapper no-border multi-select multi-select-max-width ${
                formErrors.selectedStakeholders ? "error" : ""
              }`}>
              <MultiSelect
                options={
                  individualData && individualData?.length > 0
                    ? individualData
                    : []
                }
                state={formValues.selectedStakeholders}
                setState={(selectedValue) =>
                  setFormValues((prevs) => ({
                    ...prevs,
                    selectedStakeholders: selectedValue,
                  }))
                }
                name="select multiple from the list"
              />
            </div>
          </div>

          <div className="formInputBox span4">
            <label htmlFor="featureDocumentation" className="formInputLabel">
              feature documentation <span className="required">*</span>
            </label>

            <div className="commonWrapper textAreaCommonWrapper with-auto-height no-border <ReactQuillTextEditor">
              <ReactQuillTextEditor
                value={formValues.featureDocumentation}
                setValue={(content) =>
                  onChangeTextInput(content, "featureDocumentation")
                }
                isError={formErrors?.featureDocumentation ? "formError" : ""}
                loading={loading}
              />
              {/* <ReactQuill
                id="featureDocumentation"
                name="featureDocumentation"
                className={`formInput ${
                  formErrors?.featureDocumentation ? "formError" : ""
                }`}
                placeholder="Enter Text, Links, Lists, Path..."
                value={formValues.featureDocumentation}
                onChange={(content) =>
                  onChangeTextInput(content, "featureDocumentation")
                }
              /> */}
            </div>
          </div>
        </div>

        {formValues.featureExternalLinksArray?.map((featureData, index) => (
          <div key={index} className="formInputsGrid fourGridSystem">
            <div className="formInputBox">
              <label htmlFor="link_title" className={`formInputLabel`}>
                Link title{" "}
                {formValues.featureExternalLinksArray[index].link_path && (
                  <span className="required">*</span>
                )}
              </label>

              <div className="grayLine"></div>

              <input
                type="text"
                name="link_title"
                className={`formInput ${
                  formErrors.featureExternalLinksArray?.[index]?.link_title
                    ? "formError"
                    : ""
                }`}
                placeholder="Enter Text"
                value={
                  formValues.featureExternalLinksArray[index].link_title || ""
                }
                onChange={(e) =>
                  onChangeInputInArray(e, index, "featureExternalLinksArray")
                }
              />
            </div>

            <div className="formInputBox span2">
              <label htmlFor="link_path" className={`formInputLabel`}>
                URL{" "}
                {formValues.featureExternalLinksArray[index].link_title && (
                  <span className="required">*</span>
                )}
              </label>

              <div className="grayLine"></div>

              <div className="multi-row-features">
                <input
                  type="text"
                  name="link_path"
                  className={`formInput ${
                    formErrors.featureExternalLinksArray?.[index]?.link_path
                      ? "formError"
                      : ""
                  }`}
                  placeholder="Enter URL"
                  value={
                    formValues.featureExternalLinksArray[index].link_path || ""
                  }
                  onChange={(e) =>
                    onChangeInputInArray(e, index, "featureExternalLinksArray")
                  }
                />

                <div className="action-btns-container">
                  {formValues.featureExternalLinksArray?.length !== 1 ? (
                    <button
                      className="action-btn delete-btn"
                      type="button"
                      onClick={(e) =>
                        handleRemoveOne(e, index, "featureExternalLinksArray")
                      }>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-trash3-fill"
                        viewBox="0 0 16 16">
                        <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5" />
                      </svg>
                    </button>
                  ) : null}

                  {formValues.featureExternalLinksArray?.length === 0 ||
                  (index === formValues.featureExternalLinksArray?.length - 1 &&
                    formValues.featureExternalLinksArray?.length < 10) ? (
                    <button
                      className="action-btn add-btn"
                      type="button"
                      onClick={(e) =>
                        handleAddMore(e, "featureExternalLinksArray", {
                          link_title: "",
                          link_path: "",
                        })
                      }>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-plus-circle"
                        viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
                      </svg>
                    </button>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        ))}

        <div className="grayLine"></div>

        {formValues.featureVideosArray?.map((featureData, index) => (
          <div key={index} className="formInputsGrid fourGridSystem">
            <div className="formInputBox">
              <label htmlFor="video_title" className={`formInputLabel`}>
                video title{" "}
                {formValues.featureVideosArray[index].video_path && (
                  <span className="required">*</span>
                )}
              </label>

              <div className="grayLine"></div>

              <input
                type="text"
                name="video_title"
                className={`formInput ${
                  formErrors.featureVideosArray?.[index]?.video_title
                    ? "formError"
                    : ""
                }`}
                placeholder="Enter Text"
                value={formValues.featureVideosArray[index].video_title || ""}
                onChange={(e) =>
                  onChangeInputInArray(e, index, "featureVideosArray")
                }
              />
            </div>

            <div className="formInputBox span2">
              <label htmlFor="video_path" className={`formInputLabel`}>
                Upload Video{" "}
                {formValues.featureVideosArray[index].video_title && (
                  <span className="required">*</span>
                )}
              </label>

              <div className="grayLine"></div>

              <div className="multi-row-features">
                <div className="commonWrapper video-input">
                  <input
                    accept="video/*"
                    type="file"
                    placeholder="Enter URL"
                    className={`formInput ${
                      formErrors.featureVideosArray?.[index]?.video_path
                        ? "formError"
                        : ""
                    }`}
                    name="video_path"
                    // value={
                    //   formValues.featureVideosArray[index].video_path || ""
                    // }
                    onChange={(e) =>
                      onChangeInputInArray(e, index, "featureVideosArray")
                    }
                  />
                </div>

                <div className="action-btns-container">
                  {formValues.featureVideosArray?.length !== 1 ? (
                    <button
                      className="action-btn delete-btn"
                      type="button"
                      onClick={(e) =>
                        handleRemoveOne(e, index, "featureVideosArray")
                      }>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-trash3-fill"
                        viewBox="0 0 16 16">
                        <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5" />
                      </svg>
                    </button>
                  ) : null}

                  {formValues.featureVideosArray?.length === 0 ||
                  (index === formValues.featureVideosArray?.length - 1 &&
                    formValues.featureVideosArray?.length < 10) ? (
                    <button
                      className="action-btn add-btn"
                      type="button"
                      onClick={(e) =>
                        handleAddMore(e, "featureVideosArray", {
                          video_title: "",
                          video_path: "",
                          video_link: "",
                        })
                      }>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-plus-circle"
                        viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
                      </svg>
                    </button>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        ))}

        <div className="formInputsGrid fourGridSystem">
          <div
            className={`commonWrapper commonSwitchWrapper no-border ${
              formErrors?.isNotify ? "formError" : ""
            }`}>
            <Form.Check
              type="switch"
              name="isNotify"
              label={`Notify Stakeholder`}
              checked={formValues.isNotify}
              onChange={onChangeInput}
            />
          </div>

          <div
            className={`commonWrapper commonSwitchWrapper no-border ${
              formErrors?.isActive ? "formError" : ""
            }`}>
            <Form.Check
              type="switch"
              name="isActive"
              label={`${formValues.isActive ? "Active" : "Not Active"}`}
              checked={formValues.isActive}
              onChange={onChangeInput}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default DocsForm;
